// Copyright (c) Docugami, Inc. All rights reserved.

import { Callout, DirectionalHint, FocusZone } from "@fluentui/react";
import { userFontFamily } from "components/common/Fonts";
import { emptyGray, primaryTheme } from "components/shell/presentation/AppStyles";
import { ReactNode, useRef } from "react";
import styled from "styled-components";

const SuggestionOption = styled.div`
    padding: 6px 12px;
    cursor: pointer;
    font-family: ${userFontFamily};
    font-size: 13;
    color: ${primaryTheme.palette.black};
    border-bottom: 1px solid ${emptyGray};

    :hover {
        background-color: ${primaryTheme.palette.neutralLighterAlt};
    }
`;

interface LabelSearchDropdownProps {
    suggestions: string[];
    showSuggestions: boolean;
    onSelectSuggestion: (suggestion: string) => void;
    id?: string;
    children?: ReactNode;
    onDismiss?: () => void;
}

export const LabelSearchDropdown = (props: LabelSearchDropdownProps) => {
    const labelFieldWrapperRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={labelFieldWrapperRef} style={{ position: "relative" }}>
            {props.children}
            {props.showSuggestions && (
                <Callout
                    target={labelFieldWrapperRef}
                    isBeakVisible={false}
                    gapSpace={2}
                    setInitialFocus={false}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    onDismiss={props.onDismiss}
                    style={{ minWidth: 200, zIndex: 1000 }}
                >
                    <FocusZone>
                        <div id={props.id}>
                            {props.suggestions.map(suggestion => (
                                <SuggestionOption
                                    key={suggestion}
                                    onClick={() => props.onSelectSuggestion(suggestion)}
                                >
                                    {suggestion}
                                </SuggestionOption>
                            ))}
                        </div>
                    </FocusZone>
                </Callout>
            )}
        </div>
    )
}